import React from "react";
import Footer from "../Shared/Footer";
import Banner from "./Banner";
import BusinessSummary from "./BusinessSummary";
import Features from "./Features";
import LatestNews from "./LatestNews";
import Reviews from "./Reviews";
import Tools from "./Tools";

const Home = () => {
  return (
    <>
      <Banner></Banner>
      <Features></Features>
      <Tools></Tools>
      <BusinessSummary></BusinessSummary>
      <Reviews></Reviews>
      <LatestNews></LatestNews>
      <Footer></Footer>
    </>
  );
};

export default Home;
